import { Container, ScrollContainer } from "./styles";
import { Grid, IconButton, TextField } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { getDatabase, off, query, ref } from "firebase/database";
import { sendMessage, useMessages } from "services/Chat";

import AgentBubble from "./AgentBubble";
import Loading from "components/Loading";
import { RootState } from "store";
import { Send } from "@mui/icons-material";
import UserBubble from "./UserBubble";
import { useFormik } from "formik";
import { useQueryClient } from "react-query";
import { useSelector } from "react-redux";

interface Props {
  chatUuid: string;
}

const ChatWindow: React.FC<Props> = ({ chatUuid }) => {
  const chatStore = useSelector((root: RootState) => root.chat);
  const queryClient = useQueryClient();
  const scrollRef = useRef<any>();
  const { data, isLoading, refetch } = useMessages(
    chatUuid,
    queryClient,
    chatStore.user._id
  );

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    return () => {
      off(query(ref(getDatabase(), `/chats/${chatUuid}`)));
    };
  }, [chatUuid]);

  useEffect(() => {
    if (scrollRef.current.scrollHeight) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [data]);

  const formik = useFormik({
    initialValues: {
      message: "",
    },
    onSubmit: (values) => {
      if (values.message) {
        sendMessage(values.message, chatStore, chatUuid);
        formik.resetForm();
      }
    },
  });

  return (
    <Container>
      <Loading loading={isLoading} />
      <ScrollContainer ref={scrollRef}>
        <Grid container direction="column" spacing={2}>
          {data?.map((e, i) => {
            if (e.user._id === chatStore.user._id) {
              return (
                <Grid item alignSelf="flex-end" key={e._id}>
                  <UserBubble {...e} />
                </Grid>
              );
            } else {
              return (
                <Grid item alignSelf="flex-start" key={e._id}>
                  <AgentBubble {...e} />
                </Grid>
              );
            }
          })}
        </Grid>
      </ScrollContainer>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="row"
      >
        <Grid item xs={11}>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              id="message"
              name="message"
              fullWidth
              label={"Digite suas dúvidas"}
              value={formik.values.message}
              onChange={formik.handleChange}
              error={formik.touched.message && Boolean(formik.errors.message)}
              helperText={formik.touched.message && formik.errors.message}
              inputProps={{ style: { padding: 13 } }}
            />
          </form>
        </Grid>
        <Grid item xs={1} style={{ textAlign: "center" }}>
          <IconButton onClick={() => formik.handleSubmit()}>
            <Send />
          </IconButton>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ChatWindow;
